import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import type * as React from 'react'
import { useContext, useEffect, useState } from 'react'
import { LanguageContext } from '../util/LanguageContext'
import { detectTextDirection } from '../util/TextDirection'

type AnonymousConversationSummaryProps = {
  date: string | undefined
  text: string | undefined
  id?: string
}

export const AnonymousConversationSummary: React.FC<AnonymousConversationSummaryProps> = ({
  date,
  text,
  id,
}) => {
  // スマホ用vh
  const [vh, setVh] = useState(window.innerHeight * 0.01)
  // 文字列変換用
  const translation = useContext(LanguageContext)

  useEffect(() => {
    const handleResize = () => setVh(window.innerHeight * 0.01)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: 'center', borderBottom: '2px solid #282828' }}>
                {date}
                {id ? (
                  <Box sx={{ fontSize: '18px' }}>
                    <Box>{translation['label_conversation_ID']}</Box>
                    <Box>{id}</Box>
                  </Box>
                ) : null}
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>
      </TableContainer>
      <TableContainer style={{ maxHeight: `calc(${vh * 100}px - 245px)`, overflowY: 'auto' }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <div
                  style={{
                    font: 'normal normal normal 12px Noto Sans JP',
                    direction: detectTextDirection(text || ''),
                  }}
                  dangerouslySetInnerHTML={{
                    __html: text ? text.replace(/\n/g, '<br />') : '',
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
